<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
    <div class="card">
        <div class="card-header">
            <div class="float-end fit-content h-100 d-flex align-items-center mt-2">

                <label class="col-7  text-end text-bold">{{dhcpActivated ? 'DHCP' : ('manual' | translate)}}</label>

                <div class="col-sm-4  text-end">

                <label class="switch">
                    <input type="checkbox" name="dhcpActivated" [(ngModel)]="dhcpActivated">
                    <span class="slider round"></span>
                </label>
            </div>
            </div>
            <h5 class="card-title">{{"wifi" | translate}}</h5>
            <h6 class="card-subtitle text-muted">{{"wifi_text" | translate}}</h6>
        </div>

        <div class="card-body">
            <form>
                <div class="form-group row">
                    <label class="col-form-label col-sm-4 text-sm-right">{{"ipAddress" | translate}}</label>
                    <div class="col-sm-8">
                        <input [disabled]="dhcpActivated" type="text" class="form-control"
                            [ngClass]="{'is-invalid': !dhcpActivated && ip !== '' && !isIPv4(ip)}"
                            [placeholder]="'ipAddress' | translate" name="ip" [(ngModel)]="ip">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label col-sm-4 text-sm-right">{{"subnetMask" |
                        translate}}</label>
                    <div class="col-sm-8">
                        <input [disabled]="dhcpActivated" type="text" class="form-control"
                            [ngClass]="{'is-invalid': !dhcpActivated && mask !== '' && !isIPv4(mask)}"
                            [placeholder]="'subnetMask' | translate" name="mask" [(ngModel)]="mask">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label col-sm-4 text-sm-right">{{"gateway" | translate}}</label>
                    <div class="col-sm-8">
                        <input [disabled]="dhcpActivated" type="text" class="form-control"
                            [ngClass]="{'is-invalid': !dhcpActivated && gateway !== '' && !isIPv4(gateway)}"
                            [placeholder]="'gateway' | translate" name="gateway" [(ngModel)]="gateway">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label col-sm-4 text-sm-right">{{"mac_address" |
                        translate}}</label>
                    <div class="col-sm-8">
                        <input type="text" readonly class="form-control" placeholder="{{'mac_address' | translate}}"
                            name="macaddress" value="{{deviceObj?.mac}}">
                    </div>
                </div>
                <div class="form-group row" *ngIf="hasDns">
                    <label class="col-form-label col-sm-4 text-sm-right">{{"dnsServer" |
                        translate}}</label>
                    <div class="col-sm-8">
                        <input [disabled]="dhcpActivated" type="text" class="form-control"
                            [ngClass]="{'is-invalid': !dhcpActivated && dns !== '' && !isIPv4(dns)}"
                            [placeholder]="'dnsServer' | translate" name="dns" [(ngModel)]="dns">
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-10 ms-sm-auto">
                        <button type="submit" class="btn btn-primary" (click)="save()"
                            [disabled]="saveDisabled">{{"overwrite" | translate}}</button>
                        <button type="button" class="btn btn-light ms-2" (click)="restore()"
                            [disabled]="!changesMade">{{"restore"
                            | translate}}</button>
                    </div>

                </div>
                <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error!=''">
                    <div class="alert-message">
                        {{ error }}
                    </div>
                </div>
                <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
                    <div class="alert-message">
                        {{"updatedSuccesfully" | translate}}
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
